import './GuideHeaderLauncher.css';

import { IonButton, IonIcon } from '@ionic/react';
import { helpCircleOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useTranslate } from '../../../hooks/context/useTranslate';
import useRoutes from '../../../hooks/useRoutes';
import { useQuickBookmarks } from '../../../context/QuickBookmarksContext/QuickBookmarksContext';

// Persistent entry point in the main application header: opens the guide hub.
const GuideHeaderLauncher = () => {
  const { t } = useTranslate();
  const history = useHistory();
  const routes = useRoutes();
  const { close: closeQuickBookmarks } = useQuickBookmarks();

  return (
    <IonButton
      slot="end"
      fill="clear"
      className="guide-header-launcher"
      onClick={() => {
        closeQuickBookmarks();
        history.push(routes.guides());
      }}
      title={t('guide.title')}
      data-guide-header-launcher
    >
      <IonIcon icon={helpCircleOutline} slot="start" />
      <span className="guide-header-launcher-label">{t('guide.launcher')}</span>
    </IonButton>
  );
};

export default GuideHeaderLauncher;
